module Meevo.Plugins.Register {
    "use strict"

    interface GiftReceiptSaleLineOption {
        displayName: string;
        saleLineId: Number;
        isSelected: boolean;
        quantity: number;
    }

    interface ClientGiftReceiptPreview {
        clientDisplayName: string;
        giftReceiptPreviewOptions: GiftReceiptSaleLineOption[];
    }

    export class GiftReceiptModal {

        private clientGiftReceiptOptions: ClientGiftReceiptPreview[] = [];

        static $inject = [
            "meevo.components.common.DataService",
            "$mdDialog",
            "transactionId"
        ]

        constructor(
            private dataService: Meevo.Components.BaseClasses.IDataService,
            protected mdDialog: ng.material.IDialogService,
            private transactionId: string
        ) {
            this.dataService.customMethodData(`api/Sale/${transactionId}/GiftReceiptPreview`, 'GET', null)
                .then(response => this.clientGiftReceiptOptions = response.data);
        }

        close(response: Number[] = null) {
            this.mdDialog.hide(response);
        }

        submitSelections() {
            const saleLines = this.clientGiftReceiptOptions
                .map(options => options.giftReceiptPreviewOptions)
                .reduce((accumulator, value) => accumulator.concat(value), []);

            const excludedSaleLineIds = saleLines.filter(option => !option.isSelected)
                .map(option => option.saleLineId);

            this.close( saleLines.length === excludedSaleLineIds.length ? null : excludedSaleLineIds );
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.GiftReceiptModal", GiftReceiptModal);
}